import React, { useEffect, useState } from "react";
import { Toaster } from "sonner";

import LoadingScreen from "./components/state-pages/LoadingScreen";
import NotFound from "./components/state-pages/Notfound";
import {
  ErrorIcon,
  InfoIcon,
  SuccessIcon,
  WarningIcon,
} from "./components/ui/toast-icons";
import { TooltipProvider } from "./components/ui/tooltip";
import FeatureInitializer from "./context/FeatureInitializer";
import { env } from "./lib/env";
import AdminRoutes from "./routers/AdminRoutes";
import BusinessRoutes from "./routers/BusinessRoutes";
import CustomerRoutes from "./routers/CustomerRoutes";
import { customToast } from "./utils/custom-toast";

// const AdminRoutes = React.lazy(() => import("./routers/AdminRoutes"));
// const BusinessRoutes = React.lazy(() => import("./routers/BusinessRoutes"));
// const CustomerRoutes = React.lazy(() => import("./routers/CustomerRoutes"));

const domainList = window.location.hostname.split(".");
const [subdomain] = window.location.hostname.split(".");
localStorage.setItem("subdomain", subdomain);

const App: React.FC = () => {
  // const urlSearch = new URLSearchParams(window.location.search);
  // const token = urlSearch.get("token");
  const [appState, setAppState] = useState({
    isLoading: true,
    isValidCompany: true,
  });

  const initialFetch = async (): Promise<Response | undefined> => {
    try {
      if (domainList.length === 1) {
        const landingPage = `${env.LANDING_PAGE}`;
        window.location.replace(landingPage);

        return undefined;
      } else if (subdomain.toLowerCase() === "admin") {
        setAppState({ ...appState, isLoading: false });

        return undefined;
      } else if (subdomain.toLowerCase() === "customer") {
        setAppState({ ...appState, isLoading: false });

        return undefined;
      } else if (subdomain.toLowerCase() === "www") {
        window.location.replace(`${env.LANDING_PAGE}`);

        return undefined;
      } else {
        if (localStorage.getItem("workspace")) {
          setAppState({ isLoading: false, isValidCompany: true });

          return undefined;
        }
        const res = await fetch(
          `${env.BACKEND_URL}/general/workspace/${subdomain}`,
          {
            method: "GET",
            // credentials: 'include',
          },
        );

        return res;
      }
    } catch (error) {
      customToast.error("Error fetching data");
      throw error;
    }
  };
  useEffect(() => {
    initialFetch()
      .then((res) => {
        if (!res) {
          return;
        }
        if (res.status === 404) {
          setAppState({ isLoading: false, isValidCompany: false });
        }
        if (res.status === 400 || res.status === 500) {
          setAppState({ isLoading: false, isValidCompany: false });
        }
        if (res.status === 200) {
          setAppState({ isLoading: false, isValidCompany: true });
        }
      })
      .catch(() => customToast.error("Error in initial fetch"));
  }, []);

  if (appState.isLoading) {
    return <LoadingScreen />;
  }

  if (!appState.isValidCompany && subdomain !== "ww5") {
    return <NotFound url={subdomain} />;
  }

  const getRoutes = (): React.JSX.Element => {
    if (subdomain === "admin") {
      return <AdminRoutes />;
    } else if (subdomain === "customer") {
      return <CustomerRoutes />;
    } else {
      return <BusinessRoutes />;
    }
  };

  return (
    <FeatureInitializer>
      <TooltipProvider>
        <main className='relative overflow-x-hidden overflow-y-hidden '>
          <Toaster
            duration={2000}
            icons={{
              success: SuccessIcon,
              info: InfoIcon,
              warning: WarningIcon,
              error: ErrorIcon,
            }}
          />
          {getRoutes()}
        </main>
      </TooltipProvider>
    </FeatureInitializer>
  );
};

export default App;
